import Preamble from './Preamble';

export default Preamble;
